import * as React from 'react';
import Media from 'react-media';

export default class DataControlsPanel extends React.PureComponent<DataControlPanelProps> {
    public render() {
        const {
            filterComponent,
            selectComponent,
            mobileFilterComponent,
            mobileSelectComponent,
            lozengeFilterComponent
        } = this.props;
        return (
            <section className="data-controls page-section">
                <Media query={{ maxWidth: 1023 }}>
                    <div className="data-controls__panel data-controls__panel--mobile page-section__inner">
                        {mobileFilterComponent}
                        {mobileSelectComponent}
                    </div>
                </Media>
                <Media query={{ minWidth: 1024 }}>
                    <div className="page-section">
                        <div className="data-controls__panel data-controls__panel--desktop page-section__inner">
                            {filterComponent}
                            <div className="data-controls__dropdown">{selectComponent}</div>
                        </div>
                        <div className="data-controls__lozenge-panel page-section__inner">{lozengeFilterComponent}</div>
                    </div>
                </Media>
            </section>
        );
    }
}
